import React from 'react';

const initState = {
    file: undefined,
    visible: false,
    uploadingMerchant: false,
    loading_save: false,
    itemNameSettingCurrent: null,
    isEditing: false,
    editError: false
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case 'UPDATE_MERCHANT_SUCCESS':
            return {
                ...state,
                visible: true,
                title: "Update Item",
                modal: "Item updated successfully."
            }
        case 'UPDATE_MERCHANT_FAILURE':
            return {
                ...state,
                loading_item_setting: false
            }
        case 'SAVE_MERCHANT_SUCCESS':
            let x = action.json.result
            let en1 = "entries"
            let en2 = "entries"
            let en3 = "entries"
            let d = <div style={{ fontSize: "15px" }}><div style={{ paddingBottom: "10px" }}>{x.CountCreate} {en1} added</div><div style={{ paddingBottom: "10px" }}>{x.CountEdit} {en2} updated</div><div style={{ paddingBottom: "10px" }}>{x.CountDelete} {en3} removed</div></div>
            return {
                ...state,
                visible: true,
                title: "Item master file uploaded.",
                modal: d,
                uploadingMerchant: false
            }
        case 'DELETE_MERCHANT_SUCCESS':
            return {
                ...state,
                visible: true,
                title: "Delete Item",
                modal: "Item deleted successfully.",
                visible_delete: false
            }
        case 'ON_LOAD_MERCHANT':
            action.result1 = action.result1.map(x => {
                x.CountryOfOriginCH = x.CountryOfOriginCH.trim()
                return x
            });
            return {
                ...state,
                merchants: action.result1,
                pager: action.page,
                total: action.total_item,
                loading_item_setting: false
            }
        case 'DOWNLOAD_MERCHANT':
            return {
                ...state,
                csvData: action.json.data
            }
        case 'ON_CHANGE_MERCHANT':
            let result
            result = {
                ...state,
                file: action.payload.value,
            }
            return result
        case 'ON_FILE_ERROR_OK':
            return {
                ...state,
                visible: false,
            }

        case 'UPLOAD_ITEM_SUCCESS':
            return {
                ...state
            }
        case 'DELETE_MODAL_SAGA_ITEM':
            return {
                ...state,
                visible_delete: true
            }
        case 'CANCEL_DELETE_MODAL_SAGA_ITEM':
            return {
                ...state,
                visible_delete: false
            }
        case 'UPLOAD_MERCHANT_FAILURE':
            return {
                ...state,
                uploadingMerchant: false,
            }
        case 'BEGIN_LOAD_SAGA_ITEM':
            return {
                ...state,
                loading_item_setting: true
            }
        case 'ON_UPLOAD_MERCHANT': {
            return {
                ...state,
                uploadingMerchant: true,
            }
        }
        case 'ON_LOAD_SETTING': {
            return {
                ...state,
                loading_save: true,
                itemNameSettingCurrent: null
            }
        }
        case 'ON_LOAD_SETTING_SUCCESS': {
            return {
                ...state,
                itemNameSettingCurrent: action.payload.data,
                loading_save: false
            }
        }
        case 'ON_LOAD_SETTING_FAIL': {
            return {
                ...state,
                loading_save: false
            }
        }
        case 'ON_SAVE_SETTING': {
            return {
                ...state,
                loading_save: true,
                isEditing: true,
                editError: false
            }
        }
        case 'ON_SAVE_SETTING_SUCCESS': {

            return {
                ...state,
                itemNameSettingCurrent: action.payload,
                loading_save: false,
                isEditing: false,
                editError: false
            }
        }
        case 'ON_SAVE_SETTING_FAIL': {
            return {
                ...state,
                loading_save: false,
                isEditing: false,
                editError: true
            }
        }
        default:
            return state
    }
}
export default reducer



// WEBPACK FOOTER //
// ./src/reducers/settingMerchantReducer.js